
import { Link } from 'react-router-dom';

const informationData = [
  {
    id: 1,
    date: '2025.01.15',
    category: 'お知らせ',
    title: '春の新作スタイル提案フェア開催のお知らせ',
    description: '2月1日より、春の新作ヘアスタイル提案フェアを開催いたします。最新トレンドを取り入れた春らしいスタイルをご提案させていただきます。',
  },
  {
    id: 2,
    date: '2025.01.08',
    category: 'キャンペーン',
    title: '新規のお客様限定！カット＆トリートメント特別価格',
    description: '初めてご来店いただくお客様を対象に、カット＆トリートメントを特別価格でご提供いたします。この機会にぜひご利用ください。',
  },
  {
    id: 3,
    date: '2024.12.25',
    category: 'お知らせ',
    title: '年末年始の営業時間のご案内',
    description: '年末年始の営業時間についてお知らせいたします。12月30日まで通常営業、1月1日〜3日は休業、1月4日より通常営業となります。',
  },
  {
    id: 4,
    date: '2024.12.10',
    category: 'イベント',
    title: 'ヘアケア相談会を開催いたします',
    description: '髪のお悩みやヘアケア方法について、専門スタイリストが無料でご相談を承ります。お気軽にご参加ください。',
  },
];

export default function InformationSection() {
  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-accent/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 tracking-wider text-sub" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            INFORMATION
          </h2>
          <p className="text-sm sm:text-base text-sub/70 tracking-widest" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            お知らせ
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-12">
          {informationData.map((item) => (
            <article key={item.id} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="p-6 sm:p-8">
                <div className="flex items-center gap-4 mb-4">
                  <time className="text-xs sm:text-sm text-sub/60 font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    {item.date}
                  </time>
                  <span className="px-3 py-1 bg-primary text-white text-xs rounded-full whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
                <h3 className="text-lg sm:text-xl font-bold mb-3 text-sub leading-snug" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  {item.title}
                </h3>
                <p className="text-sm text-sub/70 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/information"
            className="inline-flex items-center px-6 py-3 bg-primary text-white text-sm font-semibold rounded-full hover:bg-primary/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            すべてのお知らせを見る
            <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
